import React, { useState, useEffect } from 'react';
import { getInitials } from '../constants';
import constants from '../constants';

const CommentSection = ({ user, answer, onAddComment, existingComment, isShowContext, setIsShowContext }) => {
  const [showInput, setShowInput] = useState(false);
  const [comment, setComment] = useState('');
  console.log("comment",existingComment);
  const [savedComment, setSavedComment] = useState(null);
  const [activeButton, setActiveButton] = useState(null);
    const [showCommentSection, setShowCommentSection] = useState(!!existingComment);

  // Initialize with existing comment if provided
  useEffect(() => {
    if (existingComment) {
      setSavedComment(existingComment);
      setShowCommentSection(true);
    }
  }, [existingComment]);
  
  const handleSearch = () => {
    setIsShowContext(!isShowContext);
    console.log('Search in answer:', answer);
  };
  
  const handleCopy = () => {
    navigator.clipboard.writeText(answer);
    console.log('Answer copied to clipboard');
  };
  
  const handleMessage = () => {
    setShowCommentSection(!showCommentSection);
    // If we already have a comment, load it for editing
    if (savedComment) {
      setComment(savedComment.text);
      setShowInput(true);
      setShowCommentSection(true);
    } else {
      setShowCommentSection(!showCommentSection);
      setShowInput(!showInput);
      if (showInput) {
        setComment('');
        }
    }
  };
  
  const handleSaveComment = () => {
    if (comment.trim()) {
      // Create a new comment object with user info and timestamp
      const commentObj = {
        text: comment,
        user: user,
        timestamp: new Date()
      };
      
      // Save locally
      setSavedComment(commentObj);
      
      // Call the parent component's handler
      onAddComment(commentObj);
      
      // Reset input and hide it
      setComment('');
      setShowInput(false);
    }
  };
  
  const handleCancelEdit = () => {
    // If we have a saved comment, restore its text when canceling
    if (savedComment) {
      setComment(savedComment.text);
    } else {
      setComment('');
    }
    setShowInput(false);
  };
  
  return (
    <div className="flex flex-col mr-8 rounded-lg">
      <div className="flex-1 w-full">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center">
            <div className="text-sm text-gray-500">KI-generierte Antwort. Bitte prüfen Sie immer die Ergebnisse.</div>
          </div>
          
          {/* Action buttons */}
          <div className="flex gap-2.5">
            <button 
              onClick={() => {
                handleSearch();
                setActiveButton(activeButton === 'search' ? null : 'search');
              }} 
              title="Search"
              className={`bg-transparent border-none cursor-pointer text-gray-500 flex items-center p-1 rounded hover:bg-gray-200 ${activeButton === 'search' ? 'bg-custom-yellow' : ''}`}
            >
              <img src={constants.searchimage} alt="Search" className="h-4 w-4" />
            </button>
            <button 
              onClick={() => {
                handleCopy();
                setActiveButton(activeButton === 'copy' ? null : 'copy');
              }} 
              title="Copy"
              className={`bg-transparent border-none cursor-pointer text-gray-500 flex items-center p-1 rounded hover:bg-gray-200 ${activeButton === 'copy' ? 'bg-custom-yellow' : ''}`}
            >
              <img src={constants.copyimage} alt="Copy" className="h-4 w-4" />
            </button>
            <button 
              onClick={() => {
                handleMessage();
                setActiveButton(activeButton === 'comment' ? null : 'comment');
              }} 
              title={savedComment ? "Edit Comment" : "Add Comment"}
              className={`bg-transparent border-none cursor-pointer text-gray-500 flex items-center p-1 rounded hover:bg-gray-200 ${activeButton === 'comment' ? 'bg-custom-yellow' : ''}`}
            >
              <img src={constants.commentimage} alt="Comment" className="h-4 w-4" />
            </button>
          </div>
        </div>
        
        {showCommentSection && (
          <>
            {/* Display saved comment */}
            {savedComment && !showInput && (
              <div className="mt-3 mb-3">
                <div className="flex items-start gap-3 mb-3 pb-2">
                  {savedComment.user.profileImage ? (
                    <img 
                      src={savedComment.user.profileImage} 
                      alt={savedComment.user.name} 
                      className="w-10 h-10 rounded-full flex-shrink-0"
                    />
                  ) : (
                    <div className="inline-flex items-center font-semibold justify-center p-2 border border-transparent rounded-full shadow-sm text-white bg-custom-yellow w-10 h-10 flex-shrink-0">
                      {getInitials(savedComment.user.name)}
                    </div>
                  )}
                  <div className="flex-1">
                    <div className="mb-1" data-comment-for={answer?.id || "default"}>{savedComment.text}</div>
                    <div className="text-sm text-gray-500">
                    Kommentar von {savedComment.user.name || localStorage.getItem("name") || "User"}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Comment input area */}
            {showInput && (
              <div className="flex items-start gap-3 w-full">
                {/* User avatar */}
                {user.profileImage ? (
                  <img 
                    src={user.profileImage} 
                    alt={user.name} 
                    className="w-10 h-10 rounded-full flex-shrink-0"
                  />
                ) : (
                  <div className="inline-flex font-semibold items-center justify-center p-2 border border-transparent rounded-full shadow-sm text-white bg-custom-yellow w-10 h-10 flex-shrink-0">
                    {getInitials(user.name)}
                  </div>
                )}
                
                {/* Comment input and save button */}
                <div className="flex-1 relative">
                  <textarea
                    placeholder={savedComment ? "Edit your comment..." : "Kommentar hinzufügen…"}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className="w-full p-2.5 border border-gray-300 rounded resize-none min-h-[60px] font-inherit"
                  />
                  <div className="flex justify-end mt-2">
                    {savedComment && (
                      <button 
                        onClick={handleCancelEdit}
                        className="bg-gray-300 text-gray-700 border-none py-1.5 px-3 rounded-lg cursor-pointer mr-2"
                      >
                        Abbrechen
                      </button>
                    )}
                    <button 
                      onClick={handleSaveComment}
                      disabled={!comment.trim()}
                      className={`bg-custom-yellow text-white border-none py-1.5 px-3 rounded-lg cursor-pointer ${!comment.trim() ? 'bg-gray-400 cursor-not-allowed' : 'hover:bg-custom-yellow'}`}
                    >
                      {savedComment ? 'Aktualisieren' : 'Speichern'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CommentSection;